export default (array) => {
  const lengthArray = array.length;
  if (lengthArray === 0 || lengthArray === 1) return array.join();
  return `${array.slice(0, lengthArray - 1).join(', ')} y ${array[lengthArray - 1]}`;
};
